// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4c9229c4","977":"5194cae2"}[chunkId] + ".chunk.js";
};